webpackJsonp([65391196842345,265514319243639,2176944722876,239852729424680,25011867657060,10003711414765],{

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Export;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _assets = __webpack_require__(83);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Export() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'xs', sizeM: 'l', type: 'padding', position: 'topBottom' },
	    _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 720 },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'l', alignItems: 'center', justifyContent: 'center' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          null,
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', type: 'padding', position: 'topBottom' },
	            _react2.default.createElement(_Image2.default, _assets2.default.generateApp)
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(
	            _align2.default,
	            { type: 'center', typeM: 'left' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 's', type: 'padding', position: 'topBottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'h2', weight: 'semibold', size: 'l' },
	                'One click app export'
	              )
	            ),
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'slate' },
	              'Once you\u2019ve finished your prototype, click Download and we\u2019ll package it up as an iPhone or iPad app (.ipa).'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Images;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _assets = __webpack_require__(83);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Images() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'xs', sizeM: 'l', type: 'padding', position: 'topBottom' },
	    _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 720 },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'l', alignItems: 'center', justifyContent: 'center' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(
	            _align2.default,
	            { type: 'center', typeM: 'left' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 's', type: 'padding', position: 'topBottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'h2', weight: 'semibold', size: 'xl' },
	                'Create a prototype using images'
	              )
	            ),
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'slate' },
	              'Add your app designs or sketches to Marvel and form your prototype. We support PSD, JPG, PNG, GIF and Sketch.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          null,
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', type: 'padding', position: 'topBottom' },
	            _react2.default.createElement(_Image2.default, _assets2.default.imageFiles)
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1282:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = AndroidAppBuilder;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _IntegrationsCta = __webpack_require__(118);
	
	var _IntegrationsCta2 = _interopRequireDefault(_IntegrationsCta);
	
	var _Whitespace = __webpack_require__(35);
	
	var _Whitespace2 = _interopRequireDefault(_Whitespace);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _assets = __webpack_require__(83);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _images = __webpack_require__(670);
	
	var _images2 = _interopRequireDefault(_images);
	
	var _export = __webpack_require__(669);
	
	var _export2 = _interopRequireDefault(_export);
	
	var _integrate = __webpack_require__(671);
	
	var _integrate2 = _interopRequireDefault(_integrate);
	
	var _questions = __webpack_require__(672);
	
	var _questions2 = _interopRequireDefault(_questions);
	
	var _share = __webpack_require__(673);
	
	var _share2 = _interopRequireDefault(_share);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AndroidAppBuilder() {
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: 'iOS App Builder | Marvel',
	      meta: [{
	        name: 'description',
	        content: "Turn your prototype into a real iOS app. Make and build IPA's and iOS apps from site images and designs."
	      }, {
	        name: 'keywords',
	        content: 'ios app builder, app maker, ios maker, prototype to ios, build apps, prototype to iphone'
	      }],
	      header: true,
	      footer: true
	    },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      { size: 'l' },
	      _react2.default.createElement(_Whitespace2.default, { size: 's', sizeS: 'l', sizeM: 'xl' }),
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'center' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 's', type: 'padding', position: 'bottom' },
	          _react2.default.createElement(_Image2.default, _assets2.default.illustration)
	        ),
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 720 },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h1', weight: 'semibold', size: 'mega' },
	            'Turn your prototypes into iPhone/iPad Apps'
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 's', type: 'padding', position: 'topBottom' },
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 720 },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'xxxl', color: 'slate' },
	              'Upgrade to Marvel Pro and export prototypes into offline iOS apps (.ipa) with no coding involved, available on Marvel Pro, Company, and Enterprise plans.',
	              ' ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/pricing' },
	                _react2.default.createElement(
	                  _link2.default,
	                  { type: 'blue' },
	                  'Click here'
	                )
	              ),
	              ' ',
	              'for more info.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 's', type: 'padding', position: 'top' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', type: 'padding', position: 'bottom' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/signup' },
	              _react2.default.createElement(
	                _button2.default,
	                { size: 'large', shape: 'rounded', hover: 'blue' },
	                'Start prototyping'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_images2.default, null),
	        _react2.default.createElement(_export2.default, null),
	        _react2.default.createElement(_share2.default, null),
	        _react2.default.createElement(_integrate2.default, null),
	        _react2.default.createElement(_questions2.default, null)
	      )
	    ),
	    _react2.default.createElement(_IntegrationsCta2.default, null)
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Integrate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _assets = __webpack_require__(83);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Integrate() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'xs', sizeM: 'l', type: 'padding', position: 'topBottom' },
	    _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 720 },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'l', alignItems: 'center', justifyContent: 'center' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          null,
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', type: 'padding', position: 'topBottom' },
	            _react2.default.createElement(_Image2.default, _assets2.default.logosRetina)
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(
	            _align2.default,
	            { type: 'center', typeM: 'left' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 's', type: 'padding', position: 'topBottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'h2', weight: 'semibold', size: 'xl' },
	                'Take it further'
	              )
	            ),
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'slate' },
	              'You can link your prototype to any website or piece of content including surveys on Typeform or Survey Monkey. You can even embed YouTube videos inside your prototype.'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Questions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var questions = [{
	  id: 1,
	  name: '​Do the apps work offline?',
	  answer: "​Yes! We package up your prototype as an app (.ipa) so once ​it's installed it'll run without an internet connection."
	}, {
	  id: 2,
	  name: '​Can I put the app in the App Store?',
	  answer: _react2.default.createElement(
	    'div',
	    null,
	    'Unfortantly Apple doesn\'t accept prototype apps due to \'Not enough lasting value\'. Read more about this',
	    ' ',
	    _react2.default.createElement(
	      _link2.default,
	      {
	        type: 'blue',
	        url: 'https://developer.apple.com/app-store/review/rejections/'
	      },
	      'here'
	    ),
	    '.'
	  )
	}, {
	  id: 3,
	  name: '​Does Marvel export reusable code?',
	  answer: "​The app we generate still contains your designs as images, it's not something you would give to a developer."
	}, {
	  id: 4,
	  name: '​How much does it cost?',
	  answer: '​Marvel Pro starts at $12 per month, per person.'
	}];
	
	var items = questions.map(function (question) {
	  return _react2.default.createElement(
	    _grid.GridItem,
	    { columnSpan: 2, columnSpanM: 1, key: question.id },
	    _react2.default.createElement(
	      _align2.default,
	      { type: 'center', typeM: 'left' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 's', type: 'padding', position: 'topBottom' },
	        _react2.default.createElement(
	          _heading2.default,
	          { tag: 'h3', weight: 'semibold', size: 'l' },
	          question.name
	        )
	      ),
	      _react2.default.createElement(
	        _paragraph2.default,
	        { size: 'm', color: 'slate' },
	        question.answer
	      )
	    )
	  );
	});
	
	function Questions() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'xl', type: 'padding', position: 'topBottom' },
	    _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 720 },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'xl', type: 'padding', position: 'bottom' },
	        _react2.default.createElement(
	          _heading2.default,
	          { tag: 'h2', weight: 'semibold', size: 'xl' },
	          'Common questions'
	        )
	      ),
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'l' },
	        items
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Share;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _assets = __webpack_require__(83);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Share() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'xs', sizeM: 'l', type: 'padding', position: 'topBottom' },
	    _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 720 },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'l', alignItems: 'center', justifyContent: 'center' },
	        _react2.default.createElement(_reactResponsive2.default, { maxWidth: 1200 }),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(
	            _align2.default,
	            { type: 'center', typeM: 'left' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 's', type: 'padding', position: 'topBottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'h2', weight: 'semibold', size: 'xl' },
	                'Share the download link'
	              )
	            ),
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'slate' },
	              'Marvel will automatically generate a download page for your iOS app build. Simply send the link to your device and install.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          null,
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', type: 'padding', position: 'topBottom' },
	            _react2.default.createElement(_Image2.default, _assets2.default.devicesRetina)
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-ios-app-builder-index-js-1d90e290914dfebc7f52.js